module.exports = __webpack_public_path__ + "img/gsb39.7b32197a.png";